import * as React from 'react';
import * as LabelPrimitive from '@radix-ui/react-label';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@root/lib/utils';

const labelVariants = cva('leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 !font-[Manrope]', {
  variants: {
    variant: {
      default: 'text-[14px] font-medium text-[#1A202C]',
      text: 'text-[13px] font-normal text-[#484D56]',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> & VariantProps<typeof labelVariants>
>(({ className, variant, ...props }, ref) => (
  <LabelPrimitive.Root ref={ref} className={cn(labelVariants({ variant }), className)} {...props} />
));

Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
